import { render, staticRenderFns } from "./k-editor-json.vue?vue&type=template&id=79422ac4&"
import script from "./k-editor-json.vue?vue&type=script&lang=js&"
export * from "./k-editor-json.vue?vue&type=script&lang=js&"
import style0 from "./k-editor-json.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports